var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowWht(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.94727 15.0003C7.94703 14.7352 7.84152 14.481 7.65393 14.2937L2.53927 9.179C2.38445 9.02423 2.26165 8.84048 2.17786 8.63824C2.09408 8.43601 2.05095 8.21924 2.05095 8.00034C2.05095 7.78143 2.09408 7.56467 2.17786 7.36243C2.26165 7.16019 2.38445 6.97644 2.53927 6.82167L7.64727 1.71034C7.82942 1.52173 7.93022 1.26913 7.92794 1.00694C7.92566 0.744739 7.82049 0.493926 7.63508 0.308518C7.44968 0.12311 7.19886 0.0179412 6.93667 0.0156628C6.67447 0.0133844 6.42187 0.114179 6.23327 0.296337L1.12527 5.40367C0.438442 6.09185 0.0527029 7.0244 0.0527029 7.99667C0.0527029 8.96894 0.438442 9.9015 1.12527 10.5897L6.23993 15.7043C6.37959 15.8441 6.5575 15.9393 6.75123 15.9781C6.94497 16.0168 7.14583 15.9973 7.32847 15.922C7.51112 15.8466 7.66737 15.7189 7.77749 15.5549C7.88762 15.3909 7.9467 15.1979 7.94727 15.0003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowWht);
export default __webpack_public_path__ + "static/media/left_arrow_wht.56a777abe4d9493ef929c462802b3f87.svg";
export { ForwardRef as ReactComponent };